import { render, staticRenderFns } from "./NovaContactConsent.vue?vue&type=template&id=0d716f08&lang=pug&"
import script from "./NovaContactConsent.vue?vue&type=script&lang=js&"
export * from "./NovaContactConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports